/** Created by azhou on 2018/9/12.*/
<template>
  <!--品牌馆用户详细信息-->
  <div class="d-center-start flex-wrap">
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系人"/>{{StoreBasicInfo.contact}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="办公电话"/>{{StoreBasicInfo.tel}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="联系电话"/>{{StoreBasicInfo.mob}}</div>
    <div class="d-center-start w-50 mb-3"><left-text leftText="总机电话"/>
      {{StoreBasicInfo.hotel_tel || StoreBasicInfo.viewpoint_tel}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="可用余额"/>{{StoreBasicInfo.money/100 | formatMoney}} 元
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="活跃值"/>{{StoreBasicInfo.exp}}
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="开业时间"/>
      <span v-if="StoreBasicInfo.startdate>0">{{StoreBasicInfo.startdate | formatTimestamp}}</span>
      <span v-else>未设置</span>
    </div>
    <div class="d-center-start w-50 mb-3">
      <left-text leftText="营业时间"/>
      {{StoreBasicInfo.open_hours ? StoreBasicInfo.open_hours.split('/azhou/')[0] : '未设置'}}
      <el-popover placement="top-start" trigger="hover" v-if="StoreBasicInfo.open_hours" class="ml-1">
        <i class="el-icon-info" slot="reference"></i>
        {{StoreBasicInfo.open_hours.split('/azhou/')[1]}}
      </el-popover>
    </div>
    <div class="d-center-start w-100 mb-3">
      <left-text leftText="接待资质"/>{{StoreBasicInfo.reception_qualification | formatVar('receptionAccess')}}
    </div>
    <div class="d-center-start w-50 mt-3 mb-3 flex-wrap" v-if="StoreBasicInfo.features">
      <left-text leftText="门店设施"/>
      <span v-if="StoreBasicInfo.features.length>0">未设置</span>
      <el-tag type="success" v-else v-for="item in StoreBasicInfo.features" :key="item" class="mr-2 mb-2">{{item | formatVar('Features')}}</el-tag>
    </div>
    <div class="d-center-start mt-3 mb-3">
        <left-text leftText="主题特色"/>
        <span v-if="!StoreBasicInfo.type_label">未设置</span>
        <span type="warning" v-else v-for="item in StoreBasicInfo.type_label" :key="item" class="mr-2">{{item | formatVar('BrandTheme')}}</span>
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.banner_pic">
      <left-text leftText="轮播大图"/>
      已上传<span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','banner_pic')">{{StoreBasicInfo.banner_pic.split(',').length}}</span>张
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.pic">
      <left-text leftText="外观图片"/>
      已上传<span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','pic')">{{StoreBasicInfo.pic.split(',').length}}</span>张
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.room_arr">
      <left-text leftText="房型信息"/>
      已上传房型 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','roomList')">{{StoreBasicInfo.room_arr.length}}</span>种
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.meeting_arr">
      <left-text leftText="会议室信息"/>
      已上传会议室 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','meetList')">{{StoreBasicInfo.meeting_arr.length}}</span>种
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.onsaleArr">
      <left-text leftText="活动信息"/>
      已上传活动 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','ticket')">{{StoreBasicInfo.onsaleArr.onsale_nums}}</span>种
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.itineraryArr">
      <left-text leftText="行程信息"/>
      已上传行程 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','itineraryList')">{{StoreBasicInfo.itineraryArr.itinerary_nums}}</span>种
    </div>
    <div class="d-center-start w-50 mb-3" v-if="StoreBasicInfo.restaurantArr">
      <left-text leftText="餐饮信息"/>
      已上传餐饮 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','restaurantList')">{{StoreBasicInfo.restaurantArr.restaurant_nums}}</span>种
    </div>
    <div class="d-center-start w-100 mt-4 mb-3" v-if="StoreBasicInfo.bankcard_arr">
      <left-text leftText="银行卡信息"/>
      已绑定 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','bankcard')">{{StoreBasicInfo.bankcard_arr.length}}</span>张银行卡
    </div>
    <div class="d-center-start w-100 mb-3">
      <left-text leftText="发票信息"/>
      已添加 <span class="text-link ml-1 mr-1" @click="$emit('showItemDetail','invoice')">{{StoreBasicInfo.invoice}}</span>项发票信息
    </div>
  </div>
</template>

<script>
  import { mapState,mapGetters } from 'vuex'

  export default {
    name:'ScenicUser',
    data () {
      return {
        showIndex: 0,                       //展示酒店/民宿某一项-外景图，内景图，房型信息，会议室信息
        currentRoomMeet: null,             //当前查看的房型/会议室照片
        showRoomMeetIndex: '',              //查看房间会议室照片
        bankcardLists: [],                  //银行卡列表
        invoiceLists: [],                   //发票列表
        type: 0
      }
    },
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['userInfo'])
    },
    mounted () {
     console.log(this.StoreBasicInfo,777) 
    }
  }
</script>
